import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { FaUsers, FaSmile, FaForumbee, FaWrench } from "react-icons/fa";

const statsData = [
  {
    icon: <FaUsers className="text-4xl text-gray-500 mb-2" />,
    value: 35,
    postfix: "+",
    label: "Years Experience",
  },
  {
    icon: <FaSmile className="text-4xl text-gray-500 mb-2" />,
    value: 7000,
    postfix: "",
    label: "Happy Customers",
  },
  {
    icon: <FaForumbee className="text-4xl text-gray-500 mb-2" />,
    value: 99.99,
    postfix: "%",
    label: "Products Tracked",
  },
  {
    icon: <FaWrench className="text-4xl text-gray-500 mb-2" />,
    value: 1275,
    postfix: "",
    label: "Active Alerts",
  },
];

const Counter = ({ value, postfix }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const end = parseFloat(value);
    if (start === end) return;

    let incrementTime = 10;
    const step = end / (1000 / incrementTime);

    const timer = setInterval(() => {
      start += step;
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(end % 1 === 0 ? Math.floor(start) : start.toFixed(2));
    }, incrementTime);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <span className="text-3xl font-bold text-yellow-500">
      {count}
      {postfix}
    </span>
  );
};

const StatsSection = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <h4 className="text-yellow-500 text-lg uppercase font-semibold">Statistics</h4>
          <div className="w-16 h-1 bg-yellow-500 mx-auto my-2"></div>
          <h2 className="text-3xl md:text-5xl font-bold">{t('stats.title')}</h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {statsData.map((stat, index) => (
            <div key={index} className="flex flex-col items-center">
              {stat.icon}
              <Counter value={stat.value} postfix={stat.postfix} />
              <p className="uppercase text-lg mt-2 opacity-[0.8] font-bold">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
